import { useEffect, useState } from "react";
import { card, errMsg, field } from "@/lib/ops";

// Admin-controlled age placement: oldest age in the younger group, and which date the age is measured on.
export default function EligibilityCard({ api }) {
  const [f, setF] = useState(null);
  const [msg, setMsg] = useState("");
  useEffect(() => { api.get("/admin/eligibility").then(setF); }, [api]);
  if (!f) return null;
  const save = async () => { setMsg(""); try { setF(await api.put("/admin/eligibility", f)); setMsg("Saved — registration pages use the new rule now."); } catch (e) { setMsg(errMsg(e)); } };
  return (
    <div data-testid="eligibility-card" className={`${card} text-[#0B0F19]`}>
      <p className="font-extrabold">Age placement rule</p>
      <p className="mt-1 text-xs text-slate-500">Parents select their athlete's age (9–17); ages {f.cutoff_age} and under see 13U & Under classes, {f.cutoff_age + 1}–{f.max_age} see 14U & Up classes. Classes without an age group are open to all ages 17 and under.</p>
      <div className="mt-3 flex flex-wrap items-center gap-2 text-sm">
        <span>Younger group up to age</span>
        <input data-testid="elig-cutoff" type="number" min="8" max="16" value={f.cutoff_age} onChange={(e) => setF({ ...f, cutoff_age: Number(e.target.value) })} className={`${field} w-20`} />
        <span>measured on</span>
        <select data-testid="elig-rule" value={f.rule} onChange={(e) => setF({ ...f, rule: e.target.value })} className={field}><option value="first_session">the class's first session</option><option value="today">the registration date</option></select>
        <button data-testid="elig-save" onClick={save} className="rounded-full bg-[#0B0F19] px-4 py-2 text-sm font-bold text-white">Save</button>
        {msg && <span data-testid="elig-msg" className="text-xs font-semibold text-slate-600">{msg}</span>}
      </div>
    </div>
  );
}
